export enum PhonerModalName {
    PASSWORD = 'password',
}